__webpack_require__.p = "/static/kurssit.kansalaisopistot.fi/";